import { useOnboardingStore } from "@/store/onboardingStore";

export const STORAGE_KEYS = {
  BUILDER_ID: "builderId",
  USER_ID: "userId",
  USER_NAME: "userName",
  LEGACY_USER_NAME: "UserName",
  ONBOARDING_STORE: "onboarding-store",
  REMEMBERED_EMAIL: "rememberedEmail",
} as const;

export const getStoredUserName = () =>
  localStorage.getItem(STORAGE_KEYS.USER_NAME) || "User";

export const clearProjectStorageForLogout = () => {
  const rememberedEmail = localStorage.getItem(STORAGE_KEYS.REMEMBERED_EMAIL);

  localStorage.removeItem(STORAGE_KEYS.BUILDER_ID);
  localStorage.removeItem(STORAGE_KEYS.USER_ID);
  localStorage.removeItem(STORAGE_KEYS.USER_NAME);
  sessionStorage.removeItem(STORAGE_KEYS.LEGACY_USER_NAME);
  sessionStorage.removeItem(STORAGE_KEYS.ONBOARDING_STORE);
  useOnboardingStore.getState().resetOnboardingProgress();

  if (rememberedEmail) {
    localStorage.setItem(STORAGE_KEYS.REMEMBERED_EMAIL, rememberedEmail);
  }
};
